/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

import { jsx } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { TooltipPrimitive, type TooltipPrimitiveProps } from '@atlaskit/tooltip';

const styles = cssMap({
	tooltip: {
		backgroundColor: token('elevation.surface'),
		borderRadius: token('radius.small'),
		boxShadow: token('elevation.shadow.overlay'),
		color: token('color.text'),
		maxWidth: '300px',
		paddingBlockStart: token('space.100'),
		paddingBlockEnd: token('space.100'),
		paddingInlineStart: token('space.150'),
		paddingInlineEnd: token('space.150'),
		wordBreak: 'break-word',
	},
});

export const CustomTooltip: ReturnType<typeof forwardRef<HTMLDivElement, TooltipPrimitiveProps>> =
	forwardRef<HTMLDivElement, TooltipPrimitiveProps>(({ children, ...rest }, ref) => {
		return (
			<TooltipPrimitive {...rest} css={styles.tooltip} ref={ref}>
				{children}
			</TooltipPrimitive>
		);
	});
